import React from 'react'

import { LongTextAttributeDisplay } from 'features/views/attributes/LongTextAttributeDisplay'
import { LongTextValue } from 'features/views/attributes/LongTextValue'
import { RichTextAttributeDisplay } from 'features/views/attributes/RichTextAttributeDisplay'
import { TextAttributeDisplay } from 'features/views/attributes/TextAttributeDisplay'
import { RichTextValue } from 'features/views/attributes/types'
import { RelatedRecordWidgetType } from 'features/views/LayoutEditor/widgets/RelatedRecordWidget/types'

import { Body } from 'ui/components/Text'

type DescriptionAttributeProps = Pick<
    React.ComponentProps<typeof Body>,
    'style' | 'className' | 'size' | 'color' | 'weight' | 'mt'
> & {
    field: FieldDto
    value: unknown
    isLoading?: boolean
    maxLines?: number
    alignment?: RelatedRecordWidgetType['attrs']['alignment']
}

export const DescriptionAttribute: React.FC<DescriptionAttributeProps> = React.memo(
    function DescriptionAttribute({
        style,
        size = 'm',
        mt,
        maxLines,
        field,
        value,
        alignment,
        ...props
    }) {
        if (!field || !value) {
            return null
        }

        switch (field.type) {
            case 'string':
                return (
                    <LongTextValue
                        mt={mt}
                        textValue={value as string}
                        maxLines={maxLines}
                        flex
                        column
                        gap="xs"
                        textAlign={alignment === 'center' ? 'center' : 'left'}
                    >
                        <TextAttributeDisplay
                            key={field._sid}
                            field={field}
                            value={value as string}
                            style={{
                                ...style,
                                wordBreak: 'break-word',
                                whiteSpace: 'wrap',
                            }}
                            size={size}
                            {...props}
                        />
                    </LongTextValue>
                )

            case 'long_text':
                return (
                    <LongTextValue
                        mt={mt}
                        textValue={value as string}
                        maxLines={maxLines}
                        flex
                        column
                        gap="xs"
                        textAlign={alignment === 'center' ? 'center' : 'left'}
                    >
                        <LongTextAttributeDisplay
                            key={field._sid}
                            field={field}
                            value={value as string}
                            style={{
                                ...style,
                                wordBreak: 'break-word',
                                whiteSpace: 'wrap',
                            }}
                            size={size}
                            {...props}
                        />
                    </LongTextValue>
                )

            case 'document':
                return (
                    <LongTextValue
                        mt={mt}
                        textValue={(value as RichTextValue).plainTextContent}
                        maxLines={maxLines}
                        flex
                        column
                        gap="xs"
                        textAlign={alignment === 'center' ? 'center' : 'left'}
                    >
                        <RichTextAttributeDisplay
                            key={field._sid}
                            field={field}
                            value={value as RichTextValue}
                            style={{
                                ...style,
                                wordBreak: 'break-word',
                                whiteSpace: 'wrap',
                            }}
                            size={size}
                            {...props}
                        />
                    </LongTextValue>
                )

            default:
                return null
        }
    }
)
